/*
 * Header Scroll Behavior
 * Migrated from: packages/foundation/ui/components/Header/Header.tsx (useEffect hook)
 *
 * Auto-hides header on scroll down, shows on scroll up
 * Only active if data-auto-hide="true" attribute is set
 */

export function initHeaderScroll() {
  const headerContainer = document.querySelector(".header-container");

  if (!headerContainer) {
    return;
  }

  // Check if auto-hide is enabled via data attribute (from custom settings)
  const autoHideEnabled = headerContainer.dataset.autoHide === "true";

  if (!autoHideEnabled) {
    return;
  }

  let lastScrollY = 0;
  let ticking = false;

  const updateHeader = () => {
    const currentScrollY = window.scrollY;

    // Show header when scrolling up or at the top
    if (currentScrollY < lastScrollY || currentScrollY < 10) {
      headerContainer.setAttribute("data-hidden", "false");
    }
    // Hide header when scrolling down and past 100px
    else if (currentScrollY > lastScrollY && currentScrollY > 100) {
      headerContainer.setAttribute("data-hidden", "true");
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });

  // Cleanup function (for SPA-like navigation if needed)
  return () => {
    window.removeEventListener("scroll", onScroll);
  };
}
